/**
 * Which mode a **Lieferung** goes out under — the Versand console's filter
 * (TM-9636 / #1629).
 *
 * ⚠ **Four values over two columns.** The run's Testindikator knows `P`, `T`
 * and `E` (#1523, #1952); a Probelauf forces `T`, but stands on the run
 * (`isTestRun`) and not on the file. For the operator they are four different
 * things: a Prüf-Lieferung is synthetic data for the Abstimmung, a Probelauf is
 * Therame's own test, an Erprobung is real billing the Kasse still accepts as a
 * test, and only Echtbetrieb is money.
 *
 * ⚠ **The four never overlap.** A test office's Testlauf still writes `P`
 * (`resolveTestindikator` asks the office first), so its Lieferung is a
 * Prüf-Lieferung and not a Probelauf: one row, one mode, and every filter finds
 * it under exactly one.
 */
export var LieferungOperatingMode;
(function (LieferungOperatingMode) {
    /** A Probelauf — `isTestRun` on the run, `UNB.0035 = T` forced. */
    LieferungOperatingMode["TEST"] = "TEST";
    /** A real run whose `(IK × Kostenträger-IK)` still stands in Erprobung. */
    LieferungOperatingMode["TRIAL"] = "TRIAL";
    /** `UNB.0035 = E`. */
    LieferungOperatingMode["PRODUCTION"] = "PRODUCTION";
    /**
     * A Prüf-Lieferung — the run's `P`, `UNB.0035 = 0`, from a test office
     * (#1952, #1958).
     *
     * ⚠ **Not a Probelauf, although both are tests.** A Probelauf goes out as an
     * Erprobungsdatei; a Prüf-Lieferung is synthetic, never paid, and waits for a
     * Versand-Operator instead of the queue. Folded into {@link TEST}, it would
     * hide exactly the Lieferungen the operator has to send by hand.
     */
    LieferungOperatingMode["TEST_FILE"] = "TEST_FILE";
})(LieferungOperatingMode || (LieferungOperatingMode = {}));
//# sourceMappingURL=lieferung-operating-mode.enum.js.map